import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'

const departmentService = {
  getDepart: (params) => {
    const url = `${serverPath}${arsmoApi}/depart`
    return httpService.httpGet(url, params)
  },
}

export default departmentService



// WEBPACK FOOTER //
// ./src/services/department-service.js